// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import drawer modal styles */
.import-drawer-modal {
    width: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    
    /* Enhanced smooth transitions */
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateY(0) scale(1);
    opacity: 1;
    
    /* Initial state when opening */
    animation: slideInUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* Keyframe animation for opening */
@keyframes slideInUp {
    0% {
        transform: translateY(100%) scale(0.9);
        opacity: 0;
    }
    100% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
}

/* Keyframe animation for closing */
@keyframes slideOutDown {
    0% {
        transform: translateY(0) scale(1);
        opacity: 1;
    }
    100% {
        transform: translateY(100%) scale(0.9);
        opacity: 0;
    }
}

.closing {
    /* Apply closing animation */
    animation: slideOutDown 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform: translateY(100%) scale(0.9);
    opacity: 0;
}

/* Alternative smooth transition without keyframes (simpler approach) */
.import-drawer-modal.simple-transition {
    width: 380px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    
    /* Smooth easing transition */
    transition: all 0.35s cubic-bezier(0.4, 0.0, 0.2, 1);
    transform: translateY(0) scale(1);
    opacity: 1;
}

.simple-transition.closing {
    /* Smooth slide down with scale */
    transform: translateY(50px) scale(0.95);
    opacity: 0;
}

/* Existing styles remain the same */
.import-drawer-header {
    background-color: #F37920;
    border-radius: 0.25rem 0.25rem 0 0;
}

.import-drawer-header h5 {
    color: white;
}

.import-drawer-header .btn-link {
    font-size: 1.5rem;
    text-decoration: none;
}

.import-drawer-body {
    flex-grow: 1;
    overflow-y: auto;
    padding: 1rem;
    height: 280px;
}

.import-drawer-close-button {
    font-size: 2rem !important;
    width: 2em;
}

/* Updated folder list modal styles */
#folder-list-modal .tree-container {
    position: relative;
}

#folder-list-modal .tree-container .accordion {
    margin-bottom: 0;
}

#folder-list-modal .tree-container .accordion-item {
    border: none !important;
    background: transparent;
}

#folder-list-modal .tree-container .accordion-header .accordion-button {
    padding: 0.5rem 1rem;
    background: none;
    border: none;
    box-shadow: none;
}

#folder-list-modal .tree-container .accordion-header .accordion-button:not(.collapsed) {
    background: none;
    color: inherit;
    box-shadow: none;
}

#folder-list-modal .tree-container .accordion-header .accordion-button:focus {
    box-shadow: none;
    border: none;
}

#folder-list-modal .tree-container .accordion-body {
    padding: 0 0 0 1rem;
}

#folder-list-modal .tree-container .file-item {
    padding-left: 1rem;
    margin: 0.25rem 0;
    position: relative;
}

#folder-list-modal .tree-container .file-item .form-check {
    margin-bottom: 0;
}

#folder-list-modal .tree-container .file-item .form-check-input {
    margin-top: 0;
    margin-left: 0;
    position: relative;
}

#folder-list-modal .tree-container .file-item .form-check-label {
    margin-bottom: 0;
}

/* Ensure proper spacing and alignment for nested items */
#folder-list-modal .tree-container .accordion-item .accordion-item {
    margin-left: 1rem;
}

/* Custom scrollbar for the tree container */
#folder-list-modal .tree-container::-webkit-scrollbar {
    width: 8px;
}

#folder-list-modal .tree-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

#folder-list-modal .tree-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

#folder-list-modal .tree-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}`, "",{"version":3,"sources":["webpack://./src/components/common/importBills/importFiles.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;;IAEV,gCAAgC;IAChC,qDAAqD;IACrD,iCAAiC;IACjC,UAAU;;IAEV,+BAA+B;IAC/B,0DAA0D;AAC9D;;AAEA,mCAAmC;AACnC;IACI;QACI,sCAAsC;QACtC,UAAU;IACd;IACA;QACI,iCAAiC;QACjC,UAAU;IACd;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,iCAAiC;QACjC,UAAU;IACd;IACA;QACI,sCAAsC;QACtC,UAAU;IACd;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6DAA6D;IAC7D,sCAAsC;IACtC,UAAU;AACd;;AAEA,uEAAuE;AACvE;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;;IAEV,6BAA6B;IAC7B,oDAAoD;IACpD,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,uCAAuC;IACvC,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;IACzB,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,UAAU;AACd;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,yDAAyD;AACzD;IACI,iBAAiB;AACrB;;AAEA,4CAA4C;AAC5C;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* Import drawer modal styles */\n.import-drawer-modal {\n    width: 380px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    z-index: 1;\n    \n    /* Enhanced smooth transitions */\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform: translateY(0) scale(1);\n    opacity: 1;\n    \n    /* Initial state when opening */\n    animation: slideInUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* Keyframe animation for opening */\n@keyframes slideInUp {\n    0% {\n        transform: translateY(100%) scale(0.9);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0) scale(1);\n        opacity: 1;\n    }\n}\n\n/* Keyframe animation for closing */\n@keyframes slideOutDown {\n    0% {\n        transform: translateY(0) scale(1);\n        opacity: 1;\n    }\n    100% {\n        transform: translateY(100%) scale(0.9);\n        opacity: 0;\n    }\n}\n\n.closing {\n    /* Apply closing animation */\n    animation: slideOutDown 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform: translateY(100%) scale(0.9);\n    opacity: 0;\n}\n\n/* Alternative smooth transition without keyframes (simpler approach) */\n.import-drawer-modal.simple-transition {\n    width: 380px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    z-index: 1;\n    \n    /* Smooth easing transition */\n    transition: all 0.35s cubic-bezier(0.4, 0.0, 0.2, 1);\n    transform: translateY(0) scale(1);\n    opacity: 1;\n}\n\n.simple-transition.closing {\n    /* Smooth slide down with scale */\n    transform: translateY(50px) scale(0.95);\n    opacity: 0;\n}\n\n/* Existing styles remain the same */\n.import-drawer-header {\n    background-color: #F37920;\n    border-radius: 0.25rem 0.25rem 0 0;\n}\n\n.import-drawer-header h5 {\n    color: white;\n}\n\n.import-drawer-header .btn-link {\n    font-size: 1.5rem;\n    text-decoration: none;\n}\n\n.import-drawer-body {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 1rem;\n    height: 280px;\n}\n\n.import-drawer-close-button {\n    font-size: 2rem !important;\n    width: 2em;\n}\n\n/* Updated folder list modal styles */\n#folder-list-modal .tree-container {\n    position: relative;\n}\n\n#folder-list-modal .tree-container .accordion {\n    margin-bottom: 0;\n}\n\n#folder-list-modal .tree-container .accordion-item {\n    border: none !important;\n    background: transparent;\n}\n\n#folder-list-modal .tree-container .accordion-header .accordion-button {\n    padding: 0.5rem 1rem;\n    background: none;\n    border: none;\n    box-shadow: none;\n}\n\n#folder-list-modal .tree-container .accordion-header .accordion-button:not(.collapsed) {\n    background: none;\n    color: inherit;\n    box-shadow: none;\n}\n\n#folder-list-modal .tree-container .accordion-header .accordion-button:focus {\n    box-shadow: none;\n    border: none;\n}\n\n#folder-list-modal .tree-container .accordion-body {\n    padding: 0 0 0 1rem;\n}\n\n#folder-list-modal .tree-container .file-item {\n    padding-left: 1rem;\n    margin: 0.25rem 0;\n    position: relative;\n}\n\n#folder-list-modal .tree-container .file-item .form-check {\n    margin-bottom: 0;\n}\n\n#folder-list-modal .tree-container .file-item .form-check-input {\n    margin-top: 0;\n    margin-left: 0;\n    position: relative;\n}\n\n#folder-list-modal .tree-container .file-item .form-check-label {\n    margin-bottom: 0;\n}\n\n/* Ensure proper spacing and alignment for nested items */\n#folder-list-modal .tree-container .accordion-item .accordion-item {\n    margin-left: 1rem;\n}\n\n/* Custom scrollbar for the tree container */\n#folder-list-modal .tree-container::-webkit-scrollbar {\n    width: 8px;\n}\n\n#folder-list-modal .tree-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n#folder-list-modal .tree-container::-webkit-scrollbar-thumb {\n    background: #c1c1c1;\n    border-radius: 4px;\n}\n\n#folder-list-modal .tree-container::-webkit-scrollbar-thumb:hover {\n    background: #a8a8a8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
